module.exports = __webpack_public_path__ + "static/media/1836060.8f628711.geojson";


//////////////////
// WEBPACK FOOTER
// ./src/elections/us/GeoData/1836060.geojson
// module id = 328
// module chunks = 0